module.exports = __webpack_public_path__ + "static/media/desktop3.fb1c88c0.png";